import { createAsyncThunk } from '@reduxjs/toolkit';
import { StatsRequestProps } from 'Douleutaras/redux/data/stats/types';
import { OverviewCardFinger } from 'Douleutaras/components/OverviewCard';
import { makeRequest } from 'Douleutaras/services/apiClient';

const COMPETITORS_API = 'api/public/v3/stats/competitors';

export interface CompetitorsItem {
  user: string;
  avg: string;
  top: string;
  trend: OverviewCardFinger;
}

export interface Competitors {
  fulfillment_rate: CompetitorsItem;
  reviews: CompetitorsItem;
  response_time: CompetitorsItem;
  revenue_assigned_job: CompetitorsItem;
}

const competitorsMap: Map<string, Competitors> = new Map();

export const getCompetitors = createAsyncThunk<Competitors, StatsRequestProps>(
  'stats/competitors/get',
  async ({ catId, subCatId, from, to }, api) => {
    const request = `${COMPETITORS_API}/${catId}/${subCatId}/${from}/${to}`;
    if (!competitorsMap.has(request)) {
      const response = await makeRequest(
        request,
        {
          method: 'GET'
        }
      )(api);
      competitorsMap.set(request, response.data.data);

      return response.data.data;
    } else {
      return competitorsMap.get(request);
    }
  }
);
